export default "__VITE_ASSET__b9be47db__"